export const roles = {
    admin: 'Admin',
    tenantUser: 'TenantUser'
}

export const tenantClaimTypes = {
    siteAccess: 'SiteAccess',
    entityOwner: 'EntityOwner'
}

export const settings = {
    entityPathSeparator: '.'
}